import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths, routePath } from "../../constants/Routes";
import { setLocalSessionData } from "../Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS, NATIVE_APP_CLIENT_IDS } from "../../constants/AppConstants";
import { useQuery } from "./UseQuery";
import { useDispatch } from "react-redux";
import { NativeAppLogsInit } from "../../store/NativeAppLogs/NativeAppLogsSlice";

const useNativeAppQueryParamsToLocalStorage = () => {
    const fullURL = window.location.href;
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const queryParams = useQuery();
    const APP_CLIENT_ID = queryParams.get("client_id");
    const REQUEST_FROM = queryParams.get("request_from");
    const [ready, setReady] = useState(false);

    const isBPlusRegisterServiceCall =  useCallback(() => {
        return pathname === nativeAppRoutePaths.BPLUS.REGISTER_SERVICE? true : false;
    }, [pathname])

    const isEcoproRegisterationServiceCall = useCallback(() => {
        return pathname === routePath.PLANS? true : false;
    }, [pathname])

    useEffect(() => {
    if(
        APP_CLIENT_ID === NATIVE_APP_CLIENT_IDS.BMC
        || APP_CLIENT_ID === NATIVE_APP_CLIENT_IDS.DESKTOP 
        || REQUEST_FROM
    ){
        const isBPlusEnrollmentCall = isBPlusRegisterServiceCall();
        const isEcoProEnrollmentCall = isEcoproRegisterationServiceCall();
        const payload = {
            bplusRegistration_isEnabled: isBPlusEnrollmentCall,
            ecoproRegistration_isEnabled: isEcoProEnrollmentCall,
            params: `${(pathname === nativeAppRoutePaths.SKIP_REGISTRATION) ? fullURL.substring(fullURL.indexOf("?") + 1) : fullURL}` || null
        };
        setLocalSessionData(LOCALSESSIONDATAKEYS.NATIVE_APP_QS_INFO, JSON.stringify(payload));
        
        setReady(true);
        dispatch(NativeAppLogsInit({isAppToWeb: true}));
    } else {
        setReady(true);
    }
    // eslint-disable-next-line
  }, []);

  return {ready};
}

export default useNativeAppQueryParamsToLocalStorage;